/* oxlint-disable seeq/no-window-location -- legacy sanctioned wrapper (CRAB-64833): tests spy on these helpers
   instead of mutating the jsdom URL. New code reads URL state from React Router instead. */

/**
 * Returns a snapshot of the current browser URL.
 *
 * @deprecated In React code read URL state reactively with React Router's useLocation()/useSearchParams(), or
 * useBrowserUrl() when building absolute URLs during render. This remains the sanctioned seam for non-React code and
 * for tests that must spy on URL reads (jsdom makes window.location non-configurable).
 */
export function getBrowserUrl(): URL {
  return new URL(window.location.href);
}

/**
 * Reloads the current browser page, or — given a url — performs a full-page navigation to it, unloading the SPA. For
 * in-app route changes use React Router's useNavigate instead. Exists so tests can spy on full-page navigation: jsdom
 * makes window.location.reload/assign read-only.
 */
export function reload(url?: string): void {
  if (url === undefined) {
    window.location.reload();
  } else {
    window.location.assign(url);
  }
}
